import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITION_NUMBERS_REQUEST = 'COMPETITION_NUMBERS_REQUEST';
export const COMPETITION_NUMBERS_FAILURE = 'COMPETITION_NUMBERS_FAILURE';
export const COMPETITION_NUMBERS_SUCCESS = 'COMPETITION_NUMBERS_SUCCESS';

/**
 * Every athlete number issued in one competition.
 *
 * Returns an empty list when the competition has numbering switched off —
 * the backend decides that, so no screen tests the flag for itself.
 */
export const fetchCompetitionNumbers = (competitionId) => {
    return function(dispatch) {
        dispatch({ type: COMPETITION_NUMBERS_REQUEST, competitionId });
        return axios(apiRequestOptions(apiPath.COMPETITION_SPORTSMEN.LIST, { competition: competitionId }))
            .then(transformHttpResponse)
            .then(response => dispatch({
                type: COMPETITION_NUMBERS_SUCCESS,
                data: response.data,
                competitionId,
            }))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: COMPETITION_NUMBERS_FAILURE, competitionId });
                dispatch(errorRequestHandler(error));
            });
    };
};
